import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {usePreloadedQuery} from "react-relay";
import {Card, Col, Row} from "react-bootstrap";
import dayjs from "dayjs";
import {Link} from "react-router-dom";

export const ProviderInformationDisplayQuery = graphql`
    query ProviderInformationDisplayQuery($tin: String!) {
        queryByTin(tin: $tin) {
            id
            lineOfService {
                id
                contract {
                    name
                    id
                    terms {
                        value
                        type {
                            description
                        }
                    }
                }
                lineOfService {
                    name
                }
                effectiveFrom
                effectiveTo
                isComplex
                percentageOfBase
                otherServicesDiscountPercentage
            }
            provider {
                __typename
                id
                ... on Practitioner {
                    applicableVersion {
                        displayName
                    }
                }
                ... on Facility {
                    applicableVersion {
                        displayName
                    }
                }
            }
            }
        }
`;
const ProviderInformationDisplay = ({providerQueryRef}) => {
    const rawData = usePreloadedQuery(ProviderInformationDisplayQuery, providerQueryRef);
    const dedupedData = rawData.queryByTin.filter((obj, index, self) => {
        return index === self.findIndex((e) => e.provider.id === obj.provider.id && e.lineOfService.id === obj.lineOfService.id);
    });
    const sortData = (a, b) => {
        let order = a.name.localeCompare(b.name, "en", {sensitivity: "base"})
        if(order === 0) {
           order = a.legalContract.name.localeCompare(b.legalContract.name, "en", {sensitivity: "base"})
        }
        if(order === 0) {
            order = a.lineOfServiceName.localeCompare(b.lineOfServiceName, "en", {sensitivity: "base"});
        }
        return order;
    }
    const data = dedupedData.map(x => {
            return {
                id: x.provider.id,
                type: x.provider.__typename,
                name: x.provider.applicableVersion.displayName,
                legalContract: {name: x.lineOfService.contract.name, id: x.lineOfService.contract.id},
                daysForSubmission: x.lineOfService.contract.terms.find(t => t.type.description === "Number of days for submission of claims")?.value ?? "N/A",
                lineOfServiceName: x.lineOfService.lineOfService.name,
                lineOfServiceId: x.lineOfService.id,
                effectiveFrom: dayjs(x.lineOfService.effectiveFrom).format("L"),
                effectiveTo: dayjs(x.lineOfService.effectiveTo).format("L"),
                isComplex: x.lineOfService.isComplex ? "Yes" : "No",
                percentageOfBase: x.lineOfService.percentageOfBase ?? "N/A",
                otherServiceDiscountPercentage: x.lineOfService.otherServiceDiscountPercentage ?? "N/A"
            }
        }).sort(sortData);
    return (
        <>
            {data.map(d => (
                <Card key={d.id + "/" + d.lineOfServiceId}>
                    <Card.Header>
                        <h2 className={"h5"}>
                            <Link to={d.type === "Facility" ? "/facilities/" + d.id : "/practitioners/" + d.id} target={"_blank"} rel={"noopener noreferrer"}>{d.name}</Link> - <Link to={"/contracts/" + d.legalContract.id} target={"_blank"} rel={"noopener noreferrer"}>{d.legalContract.name}</Link> <Link to={"/contracts/" + d.legalContract.id + "/lines-of-service/" + d.lineOfServiceId} target={"_blank"} rel={"noopener noreferrer"}>{d.lineOfServiceName}</Link>
                        </h2>
                    </Card.Header>
                    <Card.Body className={"bg-light border-top"}>
                        <dl>
                            <Row lg={6} md={3} sm={1}>
                                <Col as={"dt"}>Effective Dates</Col>
                                <Col as={"dd"}>{d.effectiveFrom} - {d.effectiveTo}</Col>
                            </Row>
                            <Row lg={6} md={3} sm={1}>
                                <Col as={"dt"}>Days for Submission</Col>
                                <Col as={"dd"}>{d.daysForSubmission}</Col>
                            </Row>
                            <Row lg={6} md={3} sm={1}>
                                <Col as={"dt"}>Is Complex</Col>
                                <Col as={"dd"}>{d.isComplex.toString()}</Col>
                            </Row>
                            <Row lg={6} md={3} sm={1}>
                                <Col as={"dt"}>Percentage of Base</Col>
                                <Col as={"dd"}>{d.percentageOfBase}</Col>
                            </Row>
                            <Row lg={6} md={3} sm={1}>
                                <Col as={"dt"}>Other Services Discount %</Col>
                                <Col as={"dd"}>{d.otherServiceDiscountPercentage}</Col>
                            </Row>
                        </dl>
                    </Card.Body>
                </Card>
            ))}
        </>
    )
}
export default ProviderInformationDisplay